import GradientSavvyLogo from '../logo/gradient-savvy-logo';

type SplashScreenProps = {
  readonly growAnimationDuration?: number;
};

const DEFAULT_GROW_ANIMATION_DURATION = 1500;

export function SplashScreen({ growAnimationDuration = DEFAULT_GROW_ANIMATION_DURATION }: SplashScreenProps) {
  return (
    <div className="items-center bg-background flex flex-col h-screen justify-center left-0 p-6 fixed top-0 w-screen">
      <div className="w-64">
        <div
          className="animate-in fade-in-0 zoom-in-75 fill-mode-both"
          style={{ animationDuration: `${growAnimationDuration}ms` }}
        >
          <GradientSavvyLogo />
        </div>
      </div>
    </div>
  );
}
